export const MANAGE_ARTICLES_GET_ARTICLES = 'MANAGE_ARTICLES_GET_ARTICLES';
export const MANAGE_ARTICLES_GET_ARTICLES_SUCCESS = 'MANAGE_ARTICLES_GET_ARTICLES_SUCCESS';
export const MANAGE_ARTICLES_GET_ARTICLES_FAILURE = 'MANAGE_ARTICLES_GET_ARTICLES_FAILURE';

export const MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES = 'MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES';
export const MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS = 'MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_SUCCESS';
export const MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE = 'MANAGE_ARTICLES_PUBLISH_OR_UNPUBLISH_ARTICLES_FAILURE';

export const MANAGE_ARTICLES_REMOVE_ARTICLES = 'MANAGE_ARTICLES_REMOVE_ARTICLES';
export const MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS = 'MANAGE_ARTICLES_REMOVE_ARTICLES_SUCCESS';
export const MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE = 'MANAGE_ARTICLES_REMOVE_ARTICLES_FAILURE';

export const MANAGE_ARTICLES_PROPS_CHANGED = 'MANAGE_ARTICLES_PROPS_CHANGED';